import { css } from '@emotion/react'
import {
  cssVar,
  Spacing,
  ThemedColors,
  Typography,
  ZIndex,
} from '@opallabs/gem'

export const bannerContainer = css({
  backgroundColor: `color(from ${cssVar(ThemedColors.GemPrimary1)} display-p3 r g b / 0.3)`,
  color: cssVar(ThemedColors.GemPrimary5),
  inlineSize: '100%',
  insetBlockStart: 0,
  position: 'sticky',
  zIndex: ZIndex.Element.Level1,
})

export const bannerContent = css({
  alignItems: 'center',
  color: 'inherit',
  display: 'flex',
  gap: Spacing.M,
  justifyContent: 'center',
  paddingBlock: Spacing.S,
  paddingInline: Spacing.L,
})

export const bannerMessage = css({
  ...Typography.H50,
  alignItems: 'center',
  display: 'inline-flex',
  gap: Spacing.S,
})

export const bannerActions = css({
  alignItems: 'center',
  display: 'inline-flex',
  gap: Spacing.S,
})
